import { apiGateway } from "@/_old/services/api-gateway";

export interface CreatePlanReviewLeadParams {
  companyId: number;
  companyName?: string;
  userId?: number;
  userEmail?: string;
}

const PLAN_REVIEW_LEADS_PATH = "/api/leads/plan-review";

export async function createPlanReviewLead(
  params: CreatePlanReviewLeadParams,
): Promise<void> {
  await apiGateway.post(PLAN_REVIEW_LEADS_PATH, params);
}
